/** @jsxImportSource @emotion/react */
import { getFilledArrayOrDefault } from "../../../utils";
import SingleSelect from "../../Forms/SingleSelect";
import { useSwitchTabContext } from "./fields/useSwitchTab";

export default function TabSettings() {
    const { updatePersonalTabSettings, activeTab } = useSwitchTabContext();

    const setViewStrategy = (view_strategy, layer_type) => {
        updatePersonalTabSettings("view_strategy", view_strategy);
        updatePersonalTabSettings("layer_type", layer_type);
    };

    const layerTypeOptions = getFilledArrayOrDefault(activeTab?.view_strategies).map((item) => ({
        value: `${item.layer_type ?? ""}-${item.view_strategy ?? ""}`,
        label: item.title,
        view_strategy: item.view_strategy,
        layer_type: item.layer_type,
    }));

    return (
        <div style={{ minWidth: 180 }}>
            <SingleSelect
                unwrapped
                isClearable={false}
                field="layer_type"
                placeholder="Layer type"
                return_objects
                options={layerTypeOptions}
                post_value={layerTypeOptions.find((option) => option.layer_type === activeTab?.layer_type && option.view_strategy === activeTab?.view_strategy)}
                setValue={(_, value) => setViewStrategy(value?.view_strategy, value?.layer_type)}
            />
        </div>
    );
}
